/**
 * @generated SignedSource<<b3d603f08f693d412da6e65bc6c45134>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeaderMetadata$data = {
  readonly id: string;
  readonly issueType: {
    readonly id: string;
    readonly name: string;
  } | null | undefined;
  readonly tasklistBlocksCompletion: {
    readonly " $fragmentSpreads": FragmentRefs<"TaskListStatus">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderMenu" | "HeaderState" | "LinkedPullRequests" | "RepositoryPill" | "StickyHeaderTitle">;
  readonly " $fragmentType": "HeaderMetadata";
};
export type HeaderMetadata$key = {
  readonly " $data"?: HeaderMetadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderMetadata">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderMetadata",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderMenu"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderState"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StickyHeaderTitle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RepositoryPill"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedPullRequests"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrackedIssueCompletion",
      "kind": "LinkedField",
      "name": "tasklistBlocksCompletion",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskListStatus"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "38da9d80541380a0f9ab2297b30d6b85";

export default node;
